import React, { useState, useEffect, useCallback } from "react";

import axios from "axios";
import { Form, Spin, Button, Modal, message } from "antd";
import { ExclamationCircleOutlined, ArrowLeftOutlined } from '@ant-design/icons';

import { Redirect } from 'react-router';
import useAuth from "../../hooks/useAuth";
import "./RegistrarFormato.scss";
import Mensajes from "../Mensajes/Mensajes";
import FormRegistroFormato from "./FormRegistroFormato"
import FormRegistroFormatoPersona from "./FormRegistroFormatoPersona"
import TablaRegistros from "./TablaRegistros"
import { useRef } from "react";

const RegistraFormatos = Form.create({ name: 'parent_form' })((props) => {
    const filter = null;
    //console.log("props iniciales completo****", props.accion)
    const urlConsultaRegistro = `${localStorage.getItem('SERVERCENTRAL')}/consultaRegistro`;

    //const urlConsultaTiposAdjudicacion = `https://localhost:8443/docs_ws_adjudica/ws/consultaTiposAdjudicacion`;
    const urlGuardaRegistro = `${localStorage.getItem('SERVERCENTRAL')}/guardaRegistro`;
    //const urlGuardaAdjudicaciones = `https://localhost:8443/docs_ws_adjudica/ws/guardaAdjudicaciones`;

    const urlConsultaDatos = `${localStorage.getItem('SERVERCENTRAL')}/obtenDatoGeneral`;
    var tiempoMensaje = 5;
    const { user } = useAuth();

    const [optionsTA, setOptionsTA] = useState({
        data: [],
        loadingData: false
    });

    const [registro, setRegistro] = useState({
        data: [],
        loadingData: false
    });

    const [reg, setReg] = useState({
        data: [],
        loadingData: false
    });

    const [acciones, setAcciones] = useState({
        enableCaptura: false,
        enableModificar: false
    });

    const [visibleAlert, setVisibleAlert] = useState({
        activado: false,
        tipoMensaje: "",
        mensaje: ""
    });

    const [redirect, setRedirect] = useState({
        redirecting: false,
        url: "/formatoDiscapacidad/formatoDiscapacidad",
        state: {},
    });

    const [fecha, setFecha] = useState({
        fechaPE: ""
    });
    const [options, setOptions] = useState({
        data: [],
        loadingData: false
    });

    const [seccion, setSeccion] = useState({
        data: [],
        loadingData: false
    });
    const [secretario, setSecretario] = useState({
        data: [],
        loadingData: false
    });
    const [escrutador, setEscrutador] = useState({
        data: [],
        loadingData: false
    });


    const [cSexo, setCSexo] = useState({
        data: [],
        loadingData: false
    });
    const [cDiscapacidad, setCDiscapacidad] = useState({
        data: [],
        loadingData: false
    });
    const [cApoyo, setCApoyo] = useState({
        data: [],
        loadingData: false
    });
    const [removePersonas, setRemovePersonas] = useState({
        data: [],
    });

    const [nuevoSecretario, setNuevoSecretario] = useState("")
    const [nuevoEscrutador, setNuevoEscrutador] = useState("")
    // const [completo, setCompleto] = useState(0);
    const dateFormat = "DD-MM-YYYY";
    const timeFormat = "HH:mm";
    let nuevoFuncionario = [];

    const [general, setGeneral] = useState({
        distrito: props.distrito ? props.distrito.toString() : "",
        seccion: props.seccion ? props.seccion.toString() : "",
        casillaEspecial: props.casillaEspecial === "Sí" ? 2 : props.casillaEspecial === "No" ? 1 : "",
        secretario: props.secretario ? props.secretario.toString() : "",
        escrutador: props.escrutador ? props.escrutador.toString() : "",
        participacion: props.participacion === "Sí" ? 2 : props.participacion === "No" ? 1 : "",
        observaciones: props.observaciones ?? "",
        idGeografico: props.idGeografico ?? "",
        idFormato: props.idFormato,
        completo: props.accion ? 1 : 0,
        nombreOtroSecretario: "",
        primerApellidoOtroSecretario: "",
        segundoApellidoOtroSecretario: "",
        nombreOtroEscrutador: "",
        primerApellidoOtroEscrutador: "",
        segundoApellidoOtroEscrutador: ""
    });

    const formRegistroRef = useRef(null);
    const formRegistroPersonaRef = useRef(null);

    function doRequestOptionsGeneral() {
        //console.log("USE EFFECT *************2", options.loadingData, "****", options.data.length, "*****1", options.data, "***", general)
        if ((user.infoMenu.estadoSelec === null && user.infoMenu.detalleSelec.idEstado === 0) || (user.infoMenu.estadoSelec !== null && user.infoMenu.estadoSelec.idEstado === 0)) {
            /* setVisibleAlert({
                activado: true,
                tipoMensaje: "warning",
                mensaje: "Favor de seleccionar una entidad en el menú del proceso electoral",
            })
            return; */
            message.warning("Favor de seleccionar una entidad en el menú del proceso electoral.", tiempoMensaje);
            return;
        }
        //console.log("OPTIONS", options.loadingData)
        let data = JSON.stringify({

            idProceso: user.infoMenu.detalleSelec.idProcesoElectoral,
            idDetalleProceso: user.infoMenu.detalleSelec.idDetalleProceso,
            idEstado: user.infoMenu.estadoSelec !== null ? user.infoMenu.estadoSelec.idEstado : user.infoMenu.detalleSelec.idEstado,
            idDistrito: general.distrito != null ? general.distrito : null,
            idSeccion: general.seccion != null ? general.seccion : null,
            ambito: localStorage.getItem('AMBITO'),
            accion: props.accion == 1 ? "1" : props.accion == 2 ? "2" : "",
            idFormato: general.idFormato,
            idGeografico: general.idGeografico,


        })

        axios
            .post(
                urlConsultaDatos, data, {
                headers: {
                    'Authorization': localStorage.getItem('accessToken'),
                    'Content-Type': 'application/json',
                    Accept: "application/json",
                }
            }
            ).then(
                response => {
                    //console.log("codigo", response)
                    if (response.data.entity.code !== 200 && response.data.entity.code !== 403) {
                        /* setVisibleAlert(
                            {
                                activado: true,
                                tipoMensaje: "error",
                                mensaje: response.data.entity.causa
                            }); */
                        message.error("10.- Ocurrió un error. Comunícate al CAU", tiempoMensaje);
                    }
                    else if (response.data.entity.code === 200) {
                        if (response.data.entity.message !== null && response.data.entity.message !== "") {
                            /* setVisibleAlert(
                                {
                                    activado: true,
                                    tipoMensaje: "warning",
                                    mensaje: response.data.entity.message
                                }); */
                            message.warning(response.data.entity.message, tiempoMensaje);
                        }
                        else {
                            //console.log("response:=>", response.data.entity);

                            setOptions({
                                data: response.data.entity.select,
                                //data: response.data.select,
                                loadingData: true,
                            });
                            setSeccion({
                                data: response.data.entity.seccion,
                                //data: response.data.select,
                                loadingData: true,
                            });
                            //general.secretario="";
                            //general.escrutador="";
                            setSecretario({
                                data: response.data.entity.secretario,
                                //data: response.data.select,
                                loadingData: true,
                            });
                            setEscrutador({
                                data: response.data.entity.escrutador,
                                //data: response.data.select,
                                loadingData: true,
                            });
                            /* if (general.distrito == null) {*/
                            setCApoyo({
                                data: response.data.entity.tipoApoyo,
                                loadingData: true
                            });
                            setCDiscapacidad({
                                data: response.data.entity.tipoDiscapacidad,
                                loadingData: true
                            });
                            setCSexo({
                                data: response.data.entity.sexo,
                                loadingData: true
                            });
                        }
                        setAcciones({
                            enableCaptura: response.data.entity.enableCaptura,
                            enableModificar: response.data.entity.enableModificar
                        });
 
                        if (response.data.entity.registros != []) {
                            let i = 0;
                            response.data.entity.registros.map((value, index) => {
                                //console.log("keydinicio", value, index)
                                i++;
                                value.key = i;
                                if (value.apoyo == 0)
                                    value.tipoApoyo[0] = '0-No requirió apoyo'
                            })

                            setRegistro({
                                data: response.data.entity.registros,
                                //data: response.data.select,
                                loadingData: true,
                            });
                        }

                        /* }*/
                    }
                    else {
                        localStorage.clear();
                        // console.log("Borro el local storage");
                        window.location = "/login"
                    }
                }
            ).catch(err => {
                //console.log("Error:=>: doRequestOptions", err)
                if (err.response.status === 403) {
                    localStorage.clear();
                    window.location = "/login"
                    return;
                }
                setOptions({
                    data: [],
                    loadingData: true
                });
                setSeccion({
                    data: [],
                    loadingData: true
                });
                setSecretario({
                    data: [],
                    loadingData: true
                });
                setEscrutador({
                    data: [],
                    loadingData: true
                });
                setCApoyo({
                    data: [],
                    loadingData: true
                });
                setCDiscapacidad({
                    data: [],
                    loadingData: true
                });
                setCSexo({
                    data: [],
                    loadingData: true
                });
                /* setVisibleAlert(
                    {
                        activado: true,
                        tipoMensaje: "error",
                        mensaje: "Ha ocurrido un error al realizar la petición solicitada"
                    }); */
                message.error("Ha ocurrido un error al realizar la petición solicitada.", tiempoMensaje);
            });

        /*if(props.idTipoDocumentacion !== null && props.idTipoDocumentacion !== undefined) {
            doRequestArticulos(props.idTipoDocumentacion);
        }*/
    };

 
    function doRequestGuarda() {
        console.log("Generalrequest",general, )
        //console.log("removedata",removePersonas.data.length )
        let aux = ""
        let filtro="";
        let filtro1="";
        //console.log("Registros**", registro.data)
        if(general.participacion==2){
        filtro = registro.data.filter(item => item.id == undefined)
        //console.log("Registrosg**", filtro)
    }

        if(general.participacion==1 && registro.data!=[]){
            //console.log("Registros**f", registro.data)
            filtro1 = registro.data.filter(item => item.id !==undefined)
            //console.log("Registros**g ", filtro1)
        }

        let nomS = "", nomE = "";
        if (general.nombreOtroSecretario) {
          nomS = general.nombreOtroSecretario;
          if (general.primerApellidoOtroSecretario != "" && general.primerApellidoOtroSecretario !== undefined) {
            nomS = nomS + "-" + general.primerApellidoOtroSecretario;
          }
          if (general.segundoApellidoOtroSecretario != "" && general.segundoApellidoOtroSecretario !== undefined) {
            nomS = nomS + "-" + general.segundoApellidoOtroSecretario;
          }
        }
        if (general.nombreOtroEscrutador) {
            nomE = general.nombreOtroEscrutador;
            if (general.primerApellidoOtroEscrutador != "" && general.primerApellidoOtroEscrutador !== undefined) {
                nomE = nomE + "-" + general.primerApellidoOtroEscrutador;
            }
            if (general.segundoApellidoOtroEscrutador != "" && general.segundoApellidoOtroEscrutador !== undefined) {
                nomE = nomE + "-" + general.segundoApellidoOtroEscrutador;
            }
        }

        if (nomS != "" && general.secretario == 0) {
            nomS = "2-" + nomS
            nuevoFuncionario.push(nomS)
        }
        if (nomE != "" && general.escrutador == 0) {
            nomE = "6-" + nomE
            nuevoFuncionario.push(nomE)
        }
        //console.log("Registrosfuncionario**", filtro)

        let data = JSON.stringify({
            parametros: {
                idProceso: user.infoMenu.detalleSelec.idProcesoElectoral,
                idDetalleProceso: user.infoMenu.detalleSelec.idDetalleProceso,
                idEstado: user.infoMenu.estadoSelec !== null ? user.infoMenu.estadoSelec.idEstado : user.infoMenu.detalleSelec.idEstado,
                anioProceso: user.infoMenu.detalleSelec.anio,
                tipoProceso: user.infoMenu.detalleSelec.tipoProceso,
                ambito: localStorage.getItem('AMBITO'),
                casillaEspecial: general.casillaEspecial == 2 ? 1 : 0,
                idSecretario: general.secretario,
                idEscrutador: general.escrutador,
                participacion: general.participacion == 2 ? 1 : 0,
                observaciones: general.observaciones,
                idGeografico: general.idGeografico,
                idFormato: general.idFormato
            },

            nuevoFuncionario: (general.secretario == 0 || general.escrutador == 0) && nuevoFuncionario != [] ? nuevoFuncionario : [],
            registros: filtro!=""?filtro:null,
            removeRegistros: removePersonas.data.length > 0 ? removePersonas.data : filtro1 != ""? filtro1:null
        })
        //console.log("Registros2**", reg.data)
        //console.log("Registros3**", registro.data)
        axios
            .post(
                urlGuardaRegistro, data, {
                headers: {
                    'Authorization': localStorage.getItem('accessToken'),
                    'Content-Type': 'application/json',
                    Accept: "application/json",
                }
            }
            ).then(
                response => {
                    if (response.data.entity.code !== 200 && response.data.entity.code !== 403) {
                        /* setVisibleAlert(
                            {
                                activado: true,
                                tipoMensaje: "error",
                                mensaje: response.data.entity.causa
                            }); */
                        message.error("10.- Ocurrió un error. Comunícate al CAU", tiempoMensaje);
                    }
                    else if (response.data.entity.code === 200) {
                        if (response.data.entity.message !== null && response.data.entity.message !== "") {
                            /* setVisibleAlert(
                                {
                                    activado: true,
                                    tipoMensaje: "warning",
                                    mensaje: response.data.entity.message
                                }); */
                            message.warning(response.data.entity.message, tiempoMensaje);
                        }
                        else {
                            message.success("Se guardó correctamente el registro", tiempoMensaje);
                            //console.log("response:=>", response);
                            setRedirect({
                                redirecting: true,
                                url: "/formatoDiscapacidad/formatoDiscapacidad",
                                state:{}
                            });
                        }
                    }
                    else {
                        localStorage.clear();
                        // console.log("Borro el local storage");
                        window.location = "/login"
                    }
                }
            ).catch(err => {
                //console.log("Error:=>: doRequestOptions", err)
                if (err.response.status === 403) {
                    localStorage.clear();
                    window.location = "/login"
                    return;
                }
                /* setVisibleAlert(
                    {
                        activado: true,
                        tipoMensaje: "error",
                        mensaje: "Ha ocurrido un error al realizar la petición solicitada"
                    }); */
                message.error("Ha ocurrido un error al realizar la petición solicitada.", tiempoMensaje);
            });
    };

    function showConfirmGuardar() {
        Modal.confirm({
            title: '¿Está seguro de guardar la información?',
            icon: <ExclamationCircleOutlined />,
            //content: 'Some descriptions',
            okText: 'Aceptar',
            cancelText: 'Cancelar',
            onOk() {
                setOptions({
                    ...options,
                    loadingData: false
                });
                //console.log('Aceptar');
                doRequestGuarda();
            },
            onCancel() {
                //console.log('Cancelar');
            },
        });
    }

    function showConfirmCancelar() {
        Modal.confirm({
            title: '¿Está seguro cancelar el guardado de la información.?',
            icon: <ExclamationCircleOutlined />,
            //content: 'Some descriptions',
            okText: 'Aceptar',
            cancelText: 'Cancelar',
            onOk() {
                //console.log('Aceptar');
                setRedirect({
                    redirecting: true,
                    url: "/formatoDiscapacidad/formatoDiscapacidad",
                    state:{}

                });
            },
            onCancel() {
                //console.log('Cancelar');
            },
        });
    }



    const [pDiscapacidad, setPDiscapacidad] = useState({
        apoyo: null,
        discapacidad: [],
        sexo: null,
        tipoApoyo: []
    });


    function handleSecciones(value) {

        //console.log("cambio distrito", value)
        general.distrito = value
        general.seccion=""
        general.casillaEspecial= ""
        general.secretario=""
        general.escrutador=""
        general.participacion=""
        general.observaciones=""
        setOptions({
            ...options,
            loadingData: false
        });
      
        //console.log("cambio distritos", general.distrito)
        //console.log("cambio distritos1", props.accion)
        doRequestOptionsGeneral()
    }

    function handleFuncionarios(value) {

        //console.log("cambio seccion", value)
        general.seccion = value
        general.casillaEspecial= ""
        general.secretario=""
        general.escrutador=""
        general.participacion=""
        general.observaciones=""
        //console.log("cambio secciones", general)
        setOptions({
            ...options,
            loadingData: false
        });
        doRequestOptionsGeneral()
    }

    function handleCambio(value) {
      setGeneral({
        ...general, 
        participacion: value,
      });
    }
    //console.log("cambio total12--",general)

    function handleSubmit(value, valueDis, valueAux) {
      //console.log("value guarda entrada:=>", value);
      //console.log("value guarda entrada:=>", valueDis);
      console.log("value guarda en guardar entrada1:=>", valueAux);
      //   console.log("completo", completo)
      let nomS = "";
      let nomSAux = "";
      let nomE = "";
      let nomEAux = "";

      //console.log("value guarda13:=>", valueDis);
      //valueDis.consecutivo = registro.data.length + 1;
      /*if (valueAux.participacion == 2 && valueAux.apoyo == 0) {
        valueAux.tipoApoyo = ["0-No requirió apoyo"];
      }
      setVisibleAlert({
        activado: false,
        tipoMensaje: "",
        mensaje: "",
      });

      let i = 0;

      if (valueAux.otroSN) {
        nomS = valueAux.otroSN;
        if (valueAux.otroSPA != "" && valueAux.otroSPA !== undefined) {
          nomSAux = nomS + " " + valueAux.otroSPA;
          nomS = nomS + "-" + valueAux.otroSPA;
        }
        if (valueAux.otroSSA != "" && valueAux.otroSSA !== undefined) {
          nomSAux = nomSAux + " " + valueAux.otroSSA;
          nomS = nomS + "-" + valueAux.otroSSA;
        }

        setNuevoSecretario(nomSAux);
      }
      if (valueAux.otroEN) {
        nomE = valueAux.otroEN;
        if (valueAux.otroEPA != "" && valueAux.otroEPA !== undefined) {
          nomEAux = nomE + " " + valueAux.otroEPA;
          nomE = nomE + "-" + valueAux.otroEPA;
        }
        if (valueAux.otroESA != "" && valueAux.otroESA !== undefined) {
          nomEAux = nomEAux + " " + valueAux.otroESA;
          nomE = nomE + "-" + valueAux.otroESA;
        }
        setNuevoEscrutador(nomEAux);
      }*/
      /*setGeneral({
        distrito: value.distrito,
        seccion: value.seccion,
        casillaEspecial: value.casillaEspecial,
        secretario: valueAux.secretario == "0" ? "-1" : value.secretario,
        escrutador: valueAux.escrutador == "0" ? "-1" : value.escrutador,
        participacion: value.participacion,
        observaciones: value.observaciones,
        idGeografico: value.geografico,
        idFormato: general.idFormato,
        completo: 1,
        nSecretario: nomS != "" ? nomS : general.nSecretario,
        nEscrutador: nomE != "" ? nomE : general.nEscrutador,
      });*/
      setGeneral({
        ...general,
        distrito: value.distrito,
        seccion: value.seccion,
        casillaEspecial: value.casillaEspecial,
        //secretario: valueAux.secretario == "0" ? "-1" : value.secretario,
        //escrutador: valueAux.escrutador == "0" ? "-1" : value.escrutador,
        participacion: value.participacion,
        observaciones: value.observaciones,
        //idGeografico: value.geografico,
        //nSecretario: nomS != "" ? nomS : general.nSecretario,
        //nEscrutador: nomE != "" ? nomE : general.nEscrutador,
      });
      showConfirmGuardar();
    }


    function handleAgregar(value, valueDis, valueAux) {
      //console.log("value guarda entrada:=>", value);
      //console.log("value guarda entrada:=>", valueDis);
      console.log("value guarda entrada1:=>", valueAux);
      //   console.log("completo", completo)
      let nomS = "";
      let nomSAux = "";
      let nomE = "";
      let nomEAux = "";

      //console.log("value guarda13:=>", valueDis);
      //valueDis.consecutivo = registro.data.length + 1;
      if (general.participacion == 2 && valueAux.apoyo == 0) {
        valueAux.tipoApoyo = ["0-No requirió apoyo"];
      }

      let i = 0;

      if (general.participacion == 2) {
        registro.data.map((value, index) => {
          //console.log("keyd", value, index)
          i++;
          value.key = i;
        });
        //console.log("keydis", valueDis)
        valueAux.key = i + 1;
        console.log("keyd i++", i);

        setRegistro({
          data: [...registro.data, valueAux],
          loadingData: true,
        });
      }
    }



    //console.log("salida2", registro.data)
    //console.log("salida3", reg.data)

    function handleRemoveData(newData, deleteRow) {
        //console.log("handleRemoveData:=>newData ", newData);
        //console.log("handleRemoveData:=>deleteRow ", deleteRow);
        setVisibleAlert(
            {
                activado: false,
                tipoMensaje: "",
                mensaje: ""
            });
        let i = 0;
        newData.map((value, index) => {
            //console.log("keyd", value, index)
            i++;
            value.key = i;
        })

        setRegistro({
            data: newData,
            loadingData: true
        });

        if (deleteRow[0].id) {
            setRemovePersonas({
                data: [...removePersonas.data, deleteRow[0]]
            });
        }
    }
    //console.log("Remover", removePersonas)
    function handleLoading() {
        //console.log("handleRemoveData:=>newData ", newData);
        //console.log("handleRemoveData:=>deleteRow ", deleteRow);
        setOptionsTA(
            {
                loadingData: true
            });

    }

    const handleClose = () => {
        setVisibleAlert({
            activado: false,
            tipoMensaje: "",
            mensaje: ""
        });
    }

    function doRequestOptions() {
        //console.log("USE EFFECT *************21", options.loadingData, "****", options.data.length, "*****1", options.data, "***", general)
        if ((user.infoMenu.estadoSelec === null && user.infoMenu.detalleSelec.idEstado === 0) || (user.infoMenu.estadoSelec !== null && user.infoMenu.estadoSelec.idEstado === 0)) {
            /* setVisibleAlert({
                activado: true,
                tipoMensaje: "warning",
                mensaje: "Favor de seleccionar una entidad en el menú del proceso electoral",
            })
            return; */
            message.warning("Favor de seleccionar una entidad en el menú del proceso electoral.", tiempoMensaje);
            return;
        }
        //console.log("OPTIONS", options.loadingData)
        let data = JSON.stringify({

            idProceso: user.infoMenu.detalleSelec.idProcesoElectoral,
            idDetalleProceso: user.infoMenu.detalleSelec.idDetalleProceso,
            idEstado: user.infoMenu.estadoSelec !== null ? user.infoMenu.estadoSelec.idEstado : user.infoMenu.detalleSelec.idEstado,
            idFormato: props.idFormato,
            idGeografico: general.idGeografico,
            ambito: localStorage.getItem('AMBITO')

        })

        axios
            .post(
                urlConsultaRegistro, data, {
                headers: {
                    'Authorization': localStorage.getItem('accessToken'),
                    'Content-Type': 'application/json',
                    Accept: "application/json",
                }
            }
            ).then(
                response => {
                    //console.log("codigo", response)
                    if (response.data.entity.code !== 200 && response.data.entity.code !== 403) {
                        /* setVisibleAlert(
                            {
                                activado: true,
                                tipoMensaje: "error",
                                mensaje: response.data.entity.causa
                            }); */
                        message.error("10.- Ocurrió un error. Comunícate al CAU", tiempoMensaje);
                    }
                    else if (response.data.entity.code === 200) {
                        if (response.data.entity.message !== null && response.data.entity.message !== "") {
                            /* setVisibleAlert(
                                {
                                    activado: true,
                                    tipoMensaje: "warning",
                                    mensaje: response.data.entity.message
                                }); */
                            message.warning(response.data.entity.message, tiempoMensaje);
                        }
                        else {
                            //console.log("responsexx:=>", response.data.entity.registros);
                            setRegistro({
                                data: response.data.entity.registros,
                                //data: response.data.select,
                                loadingData: true,
                            });

                        }
                        setAcciones({
                            enableCaptura: response.data.entity.enableCaptura,
                            enableModificar: response.data.entity.enableModificar
                        });

                        /* }*/
                    }
                    else {
                        localStorage.clear();
                        // console.log("Borro el local storage");
                        window.location = "/login"
                    }
                }
            ).catch(err => {
                //console.log("Error:=>: doRequestOptions", err)
                if (err.response.status === 403) {
                    localStorage.clear();
                    window.location = "/login"
                    return;
                }
                setRegistro({
                    data: [],
                    loadingData: true
                });
                /* setVisibleAlert(
                    {
                        activado: true,
                        tipoMensaje: "error",
                        mensaje: "Ha ocurrido un error al realizar la petición solicitada"
                    }); */
                message.error("Ha ocurrido un error al realizar la petición solicitada.", tiempoMensaje);
            });

        /*if(props.idTipoDocumentacion !== null && props.idTipoDocumentacion !== undefined) {
            doRequestArticulos(props.idTipoDocumentacion);
        }*/
    };

    const handleClickModificar = useCallback(() => {
        //console.log("handleClickConsultar", idVerificacion);
        //console.log("modificar")
        setRedirect(
            {
                redirecting: true,
                url: '/registro/modificarRegistro',
                state:{
                casillaEspecial: props.casillaEspecial,
                secretario: general.secretario,
                escrutador: general.escrutador,
                participacion: props.participacion,
                observaciones: general.observaciones,
                idGeografico: general.idGeografico,
                idFormato: general.idFormato,
                accion: 2,
                distrito: props.distrito,
                seccion: props.seccion
                    }
            }
        );
    });

    const handleClickCancelar = useCallback(() => {
        showConfirmCancelar();
    });

    const handleRegistro = useCallback(() => {

        setRegistro({
            loadingData: false
        });

    });


    useEffect(() => {
        //console.log("USE EFFECT34/ *************", options.loadingData, "**", props.completo)
        if (!options.loadingData) {
            //console.log("USE EFFECT *************1", options.loadingData)
            doRequestOptionsGeneral();
        }
    }, [options]);

    const handleClickRegresar = () => {
        setRedirect({
            redirecting: true,
            url: "/formatoDiscapacidad/formatoDiscapacidad",
            state:{}
        });

    }
    const renderRedirectRegresar = () => {
        //console.log("REDIRECT1", redirect)
        if (redirect.redirecting) {
            return <Redirect
                to={{
                    pathname: redirect.url,
                    state:redirect.state
                }}
            />
        }
    }
    

    const WrappedFormRegistroFormato = Form.create({ name: 'registro' })(FormRegistroFormato);
    const WrappedFormRegistroFormatoPersona = Form.create({ name: 'registroPersona' })(FormRegistroFormatoPersona);

    const handleFormRegistro = () => {
        let valueDis = [];
        let valueReg = [];
        let valueAux;
        let value;
        formRegistroRef.current.validateFieldsAndScroll((err, values) => {
            if (!err) {
                //console.log('Received values of form11: ', values);
                //console.log("secciones", seccion.data,)
                values.geografico = seccion.data[values.seccion];
                /* Object.entries(seccion.data).map((value, index) => {
                    console.log("seccionesd1", values.seccion, "val ", value[1])
                    if (values.seccion == value[1]) {
                        values.geografico = value[0]
                        console.log("seccionesd", values.geografico,)
                        return values.geografico;
                    }
                })*/

                //console.log("secciones1", values.geografico,)
                valueAux = values;
                if (values.participacion == 2) {
                    valueDis.apoyo = values.apoyo;
                    valueDis.discapacidad = values.discapacidad;
                    valueDis.sexo = values.sexo;
                    valueDis.tipoApoyo = values.tipoApoyo;
                    //console.log('Received values of form11: ', values);
                    if (valueAux.apoyo == 2)
                        value = 1;
                    else
                        value = 0;
                    valueAux.apoyo = value;
                }
                console.log("Invocando a handleSubmit :=>")
                //showConfirmGuardar();
                handleSubmit(values, valueDis, valueAux);
            }
        });
      };
    

    return (
      <div>
        {" "}
        {renderRedirectRegresar()}
        {/*props.accion == 1 ? (
          <Button id="regresar" type="link" onClick={handleClickRegresar}>
            <ArrowLeftOutlined />
            Regresar
          </Button>
        ) : (
          ""
        )*/}
        <Button id="regresar" type="link" onClick={handleClickRegresar}>
            <ArrowLeftOutlined />
            Regresar
        </Button>
        <div className="div_consultaadj">
          {visibleAlert.activado ? (
            <Mensajes
              tipoMensaje={visibleAlert.tipoMensaje}
              mensaje={visibleAlert.mensaje}
              handleClose={handleClose}
            />
          ) : null}

          {!options.loadingData ? (
            <Spin size="large" />
          ) : (
            <>
              
                <div>
                  <WrappedFormRegistroFormato
                    // respuesta={respuesta}
                    accion={props.accion}
                    general={general}
                    setGeneral={setGeneral}
                    secciones={seccion.data}
                    distritos={options.data}
                    secretarios={secretario.data}
                    escrutadores={escrutador.data}
                    cSexo={cSexo.data}
                    cApoyo={cApoyo.data}
                    cDiscapacidad={cDiscapacidad.data}
                    //nombreArticulo={props.nombreArticulo}
                    enableCaptura={acciones.enableCaptura}
                    handleSecciones={handleSecciones}
                    handleFuncionarios={handleFuncionarios}
                    completo={general.completo}
                    handleCambio={handleCambio}
                    secretarioN={nuevoSecretario}
                    escrutadorN={nuevoEscrutador}
                    ref={formRegistroRef}
                    //handleOption={handleLoading}
                    /*handleRegistro={handleRegistro}*/
                  />
                  {general.participacion == 2 && props.accion !== 1 && (
                    <WrappedFormRegistroFormatoPersona
                      // respuesta={respuesta}
                      cSexo={cSexo.data}
                      cApoyo={cApoyo.data}
                      cDiscapacidad={cDiscapacidad.data}
                      //nombreArticulo={props.nombreArticulo}
                      enableCaptura={acciones.enableCaptura}
                      handleAgregar={handleAgregar}
                      completo={general.completo}
                      ref={formRegistroPersonaRef}
                    />
                  )}
                </div>
                {console.log(
                  "General1",
                  general.participacion,
                  "1x",
                  props.general
                )}
                {
                  //console.log("General1", registro.data.length)
                }
                {general.participacion == 2 ? (
                  <div>
                    <br />
                    <TablaRegistros
                      accion={props.accion}
                      data={registro.data}
                      enableEdit={false}
                      enableDelete={true}
                      enableCaptura={acciones.enableCaptura}
                      enableModificar={acciones.enableModificar}
                      handleRemoveData={handleRemoveData.bind(this)}
                    />
                  </div>
                ) : (
                  ""
                )}
                <div className="div_botones">
                  {props.accion != 1 ? (
                    <Button
                      className="cancelar"
                      onClick={handleClickCancelar.bind(this)}
                    >
                      {" "}
                      Cancelar{" "}
                    </Button>
                  ) : (
                    ""
                  )}
                  <Button
                    style={{ marginLeft: "10px" }}
                    className="guardar"
                    //htmlType="submit"
                    disabled={
                      !acciones.enableModificar || (general.participacion && general.participacion === 2 && registro.data.length === 0)
                    }
                    onClick={
                                props.accion == 1
                                ? handleClickModificar.bind(this)
                                : handleFormRegistro.bind(this)
                            }
                  >
                    {props.accion == 1 ? "Modificar" : "Guardar"}
                  </Button>
                </div>

                {/*props.accion == 1 && general.participacion != 2 ? (
                  <div className="div_botones">
                    <Button
                      style={{ marginLeft: "10px" }}
                      className="guardar"
                      disabled={!acciones.enableModificar}
                      onClick={handleClickModificar.bind(this)}
                    >
                      {" "}
                      Modificar
                    </Button>
                  </div>
                ) : (
                  ""
                )*/}
              
            </>
          )}
        </div>
      </div>
    );

});

export default RegistraFormatos;